namespace Matrix.Data {
    export class DocumentStoreColumns {
        static columnsKey = 'Data.DocumentStore';
    }
}
